"use strict";


const axios = require('axios');

class Delivery {
    constructor() {

    }

    static get_form_delivery() {
        return {
            id: null,
            user: null,
            order: null,
            stockage_area: null,
            attached_to: null,
            client: null,
            default_client: null,
            phone: null,
            adress: null,
            default_phone: null,
            default_address: null,
            status: null,
            season: null,
            date: null,
            delivery_date: null,
            cost: null,
            tax: null,
            number: null,
            notes: null,
            cgv: null,
            internal_notes: null,
            external_notes: null,
        }
    }

    static get_status_choices() {
        return [
            {value: "pending", text: "En attente"},
            {value: "preparing", text: "En préparation"},
            {value: "ready", text: "Prêt pour la livraison"},
            {value: "processing", text: "Effectuer la livraison"},
            {value: "delivered", text: "Livré"},
            {value: "sent", text: "Envoyé"},
            {value: "canceled", text: "Annulé"},
        ]
    }

    static get_season_choices() {
        return [
            {value: "summer", text: "Été"},
            {value: "winter", text: "Hiver"},
            {value: "autumn", text: "Automne"},
            {value: "spring", text: "Printemps"},
        ]
    }

    static async get_deliveries_with_request(request) {
        let deliveries;
        let rows;
        await axios({
            method: "get",
            url: process.env.VUE_APP_PRODUCTS_API + "deliveries/" + request,
        })
            .then((response) => {
                deliveries = response.data.results;
                rows = response.data.count;
            })
            .catch((error) => {
                console.log(error);
            });
        return [deliveries, rows];
    }

    static async get_deliveries() {
        let deliveries
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "deliveries/",
        })
            .then((response) => {
                deliveries = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return deliveries;
    }

    static async get_delivery_by_id(id) {
        let delivery
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "deliveries/" + id,
        })
            .then((response) => {
                delivery = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return delivery;
    }

    static async create_delivery(form_delivery) {
        let delivery_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "deliveries/",
            data: form_delivery
        })
            .then((response) => {
                delivery_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return delivery_form;
    }

    static async delete_delivery(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "deliveries/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_delivery(id, form_delivery) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "deliveries/" + id + '/',
            data: form_delivery
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

}

class Delivery_document {
    constructor() {

    }

    static get_form_delivery_document() {
        return {
            id: null,
            user: null,
            delivery: null,
            document: null,
            title: null,
            size: null,
            created_at: null,
        }
    }

    static async get_delivery_documents_by_delivery_id(id) {
        let documents
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "delivery-documents?delivery=" + id,
        })
            .then((response) => {
                documents = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return documents;
    }

    static async create_delivery_document(form_delivery_document) {
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "delivery-documents/",
            data: form_delivery_document
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async delete_delivery_document(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "delivery-documents/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Delivery_note {
    constructor() {

    }

    static get_form_delivery_note() {
        return {
            id: null,
            user: null,
            created_at: null,
            text: null,
            delivery: null,
            pin: false,
        }
    }

    static async get_delivery_notes_by_delivery_id(id) {
        let notes
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "delivery-notes?delivery=" + id,
        })
            .then((response) => {
                notes = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return notes;
    }

    static async create_delivery_note(form_delivery_note) {
        let delivery_note_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "delivery-notes/",
            data: form_delivery_note
        })
            .then((response) => {
                delivery_note_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return delivery_note_form
    }

    static async delete_delivery_note(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "delivery-notes/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_delivery_note(id, form_delivery_note) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "delivery-notes/" + id + '/',
            data: form_delivery_note
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Delivery_line {
    constructor() {

    }

    static get_form_delivery_line() {
        return {
            id: null,
            product: null,
            quantity: null,
            variation: null,
            delivery: null,
            returned: null,
        }
    }

    static async get_delivery_lines_by_delivery_id(id) {
        let lines
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "delivery-lines?delivery=" + id,
        })
            .then((response) => {
                lines = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return lines;
    }

    static async create_delivery_line(form_delivery_line) {
        let delivery_line_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "delivery-lines/",
            data: form_delivery_line
        })
            .then((response) => {
                delivery_line_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return delivery_line_form
    }

    static async delete_delivery_line(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "delivery-lines/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_delivery_line(id, form_delivery_line) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "delivery-lines/" + id + '/',
            data: form_delivery_line
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

}

class Product {
    constructor() {

    }

    static get_form_product() {
        return {
            id: null,
            name: null,
            reference: null,
            description: null,
            manufacturer_description: null,
            cost_price: null,
            buying_price: null,
            saling_price: null,
            weigth: null,
            tax_amount: null,
            type: null,
            category: null,
            prices: null,
            manufacturer: null,
            product: null,
            sku: null,
            barcode: null,
            sh_code: null,
            stock: null,
            stock_alert: null,
            supply_alert: null,
            expiration_date: null,
            optimal_consumption_date: null,
            tags: null,
            service: null,
            origin_country: null,
            brand: null,
            season: null,
            variations: null,
        }
    }

    static get_product_type_choices() {
        return [
            {value: "physical", text: "Physique"},
            {value: "service", text: "Service"},
        ]
    }

    static get_season_choices() {
        return [
            {value: "summer", text: "Été"},
            {value: "winter", text: "Hiver"},
            {value: "autumn", text: "Automne"},
            {value: "spring", text: "Printemps"},
        ]
    }

    static async get_products_with_request(request) {
        let products;
        let rows;
        await axios({
            method: "get",
            url: process.env.VUE_APP_PRODUCTS_API + "products/" + request,
        })
            .then((response) => {
                products = response.data.results;
                rows = response.data.count;
            })
            .catch((error) => {
                console.log(error);
            });
        return [products, rows];
    }

    static async get_products() {
        let products
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "products/",
        })
            .then((response) => {
                products = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return products;
    }

    static async get_product_by_id(id) {
        let product
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "products/" + id,
        })
            .then((response) => {
                product = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return product;
    }

    static async create_product(form_product) {
        let product_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "products/",
            data: form_product
        })
            .then((response) => {
                product_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return product_form;
    }

    static async delete_product(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "products/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_product(id, form_product) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "products/" + id + '/',
            data: form_product
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Product_pack {
    constructor() {

    }

    static get_product_pack_form() {
        return {
            id: null,
            name: null,
            reference: null,
            description: null,
            manufacturer_description: null,
            cost_price: null,
            buying_price: null,
            saling_price: null,
            weigth: null,
            tax_amount: null,
            sku: null,
            barcode: null,
            sh_code: null,
            stock: null,
            stock_alert: null,
            supply_stock: null,
            expiration_date: null,
            optimal_consumption_date: null,
        }
    }

    static async get_product_packs() {
        let products_packs
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-packs/",
        })
            .then((response) => {
                products_packs = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return products_packs;
    }

    static async get_product_pack_by_id(id) {
        let product_pack
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-packs/" + id,
        })
            .then((response) => {
                product_pack = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return product_pack;
    }

    static async create_product_pack(form_product_pack) {
        let product_pack_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-packs/",
            data: form_product_pack
        })
            .then((response) => {
                product_pack_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return product_pack_form;
    }

    static async delete_product_pack(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-packs/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_product_pack(id, form_product_pack) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-packs/" + id + '/',
            data: form_product_pack
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

}

class Product_pack_item {
    constructor() {

    }

    static get_form_product_pack_item() {
        return {
            id: null,
            product: null,
            quanitity: null,
            variation: null,
            product_pack: null,
        }
    }

    static async get_product_pack_items() {
        let product_pack_items
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-pack-items/",
        })
            .then((response) => {
                product_pack_items = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return product_pack_items;
    }

    static async get_product_pack_item_by_id(id) {
        let product_pack_item
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-pack-items/" + id,
        })
            .then((response) => {
                product_pack_item = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return product_pack_item;
    }

    static async get_product_pack_item_by_product_pack_id(id) {
        let product_pack_item
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-pack-items?product_pack=" + id,
        })
            .then((response) => {
                product_pack_item = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return product_pack_item;
    }

    static async create_product_pack_item(form_product_pack_item) {
        let product_pack_item_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-pack-items/",
            data: form_product_pack_item
        })
            .then((response) => {
                product_pack_item_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return product_pack_item_form;
    }

    static async delete_product_pack_item(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-pack-items" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_product_pack_item(id, form_product_pack_item) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-pack-items/" + id + '/',
            data: form_product_pack_item
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

}

class Product_variation {
    constructor() {

    }

    static get_form_product_variation() {
        return {
            id: null,
            name: null,
            description: null,
            cost_price: null,
            saling_price: null,
            tax_amount: null,
            product: null,
            price: null,
            weigth: null,
            stock: null,
            stock_alert: null,
            supply_stock: null,
            barcode: null,
            sku: null,
        }
    }

    static async get_product_variations() {
        let product_variations
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-variations/",
        })
            .then((response) => {
                product_variations = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return product_variations;
    }

    static async get_product_variation_by_id(id) {
        let product_variation
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-variations/" + id,
        })
            .then((response) => {
                product_variation = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return product_variation;
    }

    static async get_product_variation_by_product_id(id) {
        let product_variation
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-variations?product=" + id,
        })
            .then((response) => {
                product_variation = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return product_variation;
    }

    static async create_product_variation(form_product_variation) {
        let product_variation_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-variations/",
            data: form_product_variation
        })
            .then((response) => {
                product_variation_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return product_variation_form;
    }

    static async delete_product_variation(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-variations" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_product_variation(id, form_product_variation) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "product-variations/" + id + '/',
            data: form_product_variation
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Manufacturer {
    constructor() {

    }

    static get_form_manufacturer() {
        return {
            id: null,
            name: null,
            description: null,
            address: null,
            postcode: null,
            city: null,
            number: null,
            email: null,
            country: null,
            twitter_url: null,
            facebook_url: null,
            linkedin_url: null,
            youtube_url: null,
            instagram_url: null,
            website: null,
            active: null,
            default_currency: null,
            default_tax: null,
            default_price: null,
            default_discount: null,
            sku: null,
        }
    }

    static async get_manufacturers() {
        let manufacturers
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturers/",
        })
            .then((response) => {
                manufacturers = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return manufacturers;
    }

    static async get_manufacturer_by_id(id) {
        let manufacturer
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturers/" + id,
        })
            .then((response) => {
                manufacturer = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return manufacturer;
    }

    static async create_manufacturer(form_manufacturer) {
        let manufacturer_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturers/",
            data: form_manufacturer
        })
            .then((response) => {
                manufacturer_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return manufacturer_form;
    }

    static async delete_manufacturer(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturers/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_manufacturer(id, form_manufacturer) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturers/" + id + '/',
            data: form_manufacturer
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Manufacturer_document {
    constructor() {

    }

    static get_form_manufacturer_document() {
        return {
            id: null,
            user: null,
            manufacturer: null,
            document: null,
            title: null,
            size: null,
            created_at: null,
        }
    }

    static async get_manufacturer_documents_by_manufacturer_id(id) {
        let documents
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturer-documents?manufacturer=" + id,
        })
            .then((response) => {
                documents = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return documents;
    }

    static async create_manufacturer_document(form_manufacturer_document) {
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturer-documents/",
            data: form_manufacturer_document
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async delete_manufacturer_document(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturer-documents/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Manufacturer_note {
    constructor() {

    }

    static get_form_manufacturer_note() {
        return {
            user: null,
            text: null,
            manufacturer: null,
            pin: false,
        }
    }

    static async get_manufacturer_notes_by_manufacturer_id(id) {
        let notes
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturer-notes?manufacturer=" + id,
        })
            .then((response) => {
                notes = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return notes;
    }

    static async create_manufacturer_note(form_manufacturer_note) {
        let manufacturer_note_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturer-notes/",
            data: form_manufacturer_note
        })
            .then((response) => {
                manufacturer_note_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return manufacturer_note_form
    }

    static async delete_manufacturer_note(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturer-notes/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_manufacturer_note(id, form_manufacturer_note) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturer-notes/" + id + '/',
            data: form_manufacturer_note
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Order {
    constructor() {

    }

    static async get_orders() {
        let orders
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "orders/",
        })
            .then((response) => {
                orders = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return orders;
    }

    static async create_order(form_order) {
        let order_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "manufacturer-notes/",
            data: form_order
        })
            .then((response) => {
                order_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return order_form
    }

    static get_status_choices() {
        return [
            {value: "active", text: "Actif"},
            {value: "canceled", text: "Annulé"},
        ]
    }


}


class Purchase_order {
    constructor() {

    }

    static get_status_choices() {
        return [
            {value: "pending", text: "En attente"},
            {value: "active", text: "Actif"},
            {value: "canceled", text: "Annulé"},
            {value: "receipted", text: "Produits reçu"},
            {value: "finish", text: "Terminé"},
        ]
    }

    static get_season_choices() {
        return [
            {value: "summer", text: "Été"},
            {value: "winter", text: "Hiver"},
            {value: "autumn", text: "Automne"},
            {value: "spring", text: "Printemps"},
        ]
    }

    static get_currency_choices() {
        return [
            {value: "eur", text: "EUR"},
            // {value: "usd", text: "USD"},
        ]
    }

    static get_price_levels_choices() {
        return [
            {text: "Prix d'achat", value: "purchase_price"},
            {text: "Prix Revendeur", value: "reseller_price"},
            {text: "Prix de vente conseillé", value: "advised_sale_price"},
        ]
    }
}

class Stockage_area {
    constructor() {

    }

    static get_form_stockage_areas() {
        return {
            id: null,
            user: null,
            name: null,
            description: null,
            address: null,
            contact: null,
            postcode: null,
            city: null,
            country: null,
            email: null,
            phone: null,
            products: [],
            company: null,
            delivery_cost: null,
            type: null,
            status: "active",
            replace_names: null,
        }
    }

    static get_status_choices() {
        return [
            {value: "active", text: "Actif"},
            {value: "inactive", text: "Inactif"},
        ]
    }

    static get_stockage_area_type_choices() {
        return [
            {value: "warehouse", text: "Entrepôt"},
            {value: "store", text: "Magasin"},
        ]
    }

    static async get_stockage_areas() {
        let stockage_areas
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "stockage-areas/",
        })
            .then((response) => {
                stockage_areas = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return stockage_areas;
    }

    static async get_stockage_areas_with_request(request) {
        let stockage_areas;
        let rows;
        await axios({
            method: "get",
            url: process.env.VUE_APP_PRODUCTS_API + "stockage-areas/" + request,
        })
            .then((response) => {
                stockage_areas = response.data.results;
                rows = response.data.count;
            })
            .catch((error) => {
                console.log(error);
            });
        return [stockage_areas, rows];
    }

    static async get_stockage_areas_by_id(id) {
        let stockage_areas
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "stockage-areas/" + id,
        })
            .then((response) => {
                stockage_areas = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return stockage_areas;
    }

    static async create_stockage_areas(form_stockage_areas) {
        let stockage_areas_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "stockage-areas/",
            data: form_stockage_areas
        })
            .then((response) => {
                stockage_areas_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return stockage_areas_form;
    }

    static async delete_stockage_areas(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "stockage-areas/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_stockage_areas(id, form_stockage_areas) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "stockage-areas/" + id + '/',
            data: form_stockage_areas
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

}

class Client_delivery {
    constructor() {

    }

    static get_form_client_delivery() {
        return {
            id: null,
            user: null,
            order: null,
            status: null,
            date: null,
            cost: null,
            tax: null,
        }
    }

    static get_client_delivery_status_choices() {
        return [
            {value: "pending", text: "En attente"},
            {value: "canceled", text: "Annulé"},
            {value: "in transit", text: "En transit"},
            {value: "delivered", text: "Livré"},
        ]
    }

    static async get_client_deliveries() {
        let client_deliveries
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-deliveries/",
        })
            .then((response) => {
                client_deliveries = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return client_deliveries;
    }

    static async get_client_delivery_by_id(id) {
        let client_delivery
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-deliveries/" + id,
        })
            .then((response) => {
                client_delivery = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return client_delivery;
    }

    static async create_client_delivery(form_client_delivery) {
        let client_delivery_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-deliveries/",
            data: form_client_delivery
        })
            .then((response) => {
                client_delivery_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return client_delivery_form;
    }

    static async delete_client_delivery(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-deliveries/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_client_delivery(id, form_client_delivery) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-deliveries/" + id + '/',
            data: form_client_delivery
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Client_delivery_document {
    constructor() {

    }

    static get_form_client_delivery_document() {
        return {
            user: null,
            client_delivery: null,
            document: null,
            title: null,
            size: null,
        }
    }

    static async get_client_delivery_documents_by_client_delivery_id(id) {
        let documents
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-delivery-documents?client_delivery=" + id,
        })
            .then((response) => {
                documents = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return documents;
    }

    static async create_client_delivery_document(form_client_delivery_document) {
        let client_delivery_document_form;
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-delivery-documents/",
            data: form_client_delivery_document
        })
            .then((response) => {
                client_delivery_document_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return client_delivery_document_form;
    }

    static async delete_client_delivery_document(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-delivery-documents/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Client_delivery_note {
    constructor() {

    }

    static get_form_client_delivery_note() {
        return {
            user: null,
            text: null,
            client_delivery: null,
            pin: false,
        }
    }

    static async get_client_delivery_notes_by_client_delivery_id(id) {
        let notes
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-delivery-notes?client_delivery=" + id,
        })
            .then((response) => {
                notes = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return notes;
    }

    static async create_client_delivery_note(form_client_delivery_note) {
        let client_delivery_note_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-delivery-notes/",
            data: form_client_delivery_note
        })
            .then((response) => {
                client_delivery_note_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return client_delivery_note_form
    }

    static async delete_client_delivery_note(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-delivery-notes/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_client_delivery_note(id, form_client_delivery_note) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "client-delivery-notes/" + id + '/',
            data: form_client_delivery_note
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Receipt {
    constructor() {

    }

    static get_form_manufacturer() {
        return {
            id: null,
            user: null,
            transaction: null,
            status: null,
            date: null,
            stockage_area: null,
            attached_to: null,
            client: null,
            default_client: null,
            phone: null,
            address: null,
            default_phone: null,
            default_address: null,
            season: null,
            delivery_date: null,
            cost: null,
            tax: null,
            number: null,
            cgv: null,
            internat_notes: null,
            external_references: null,
            purchase_order: null,
        }
    }

    static get_receipt_status_choices() {
        return [
            {value: "receipted", text: "Réceptionné"},
            {value: "pending", text: "En attente"},
            {value: "canceled", text: "Annulé"},
        ]
    }

    static get_receipt_season_choices() {
        return [
            {value: "summer", text: "Réceptionné"},
            {value: "winter", text: "En attente"},
            {value: "autumn", text: "Annulé"},
            {value: "spring", text: "Printemps"},
        ]
    }

    static async get_receipts() {
        let receipts
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipts/",
        })
            .then((response) => {
                receipts = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return receipts;
    }

    static async get_receipt_by_id(id) {
        let receipt
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipts/" + id,
        })
            .then((response) => {
                receipt = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return receipt;
    }

    static async create_receipt(form_receipt) {
        let receipt_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipts/",
            data: form_receipt
        })
            .then((response) => {
                receipt_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return receipt_form;
    }

    static async delete_receipt(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipts/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_receipt(id, form_receipt) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipts/" + id + '/',
            data: form_receipt
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Receipt_note {
    constructor() {

    }

    static get_form_receipt_note() {
        return {
            user: null,
            text: null,
            receipt: null,
            pin: false,
        }
    }

    static async get_receipt_notes_by_receipt_id(id) {
        let notes
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipt-notes?receipt=" + id,
        })
            .then((response) => {
                notes = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return notes;
    }

    static async create_receipt_note(form_receipt_note) {
        let receipt_note_form
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipt-notes/",
            data: form_receipt_note
        })
            .then((response) => {
                receipt_note_form = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return receipt_note_form
    }

    static async delete_receipt_note(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipt-notes/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async edit_receipt_note(id, form_receipt_note) {
        await axios({
            method: "put",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipt-notes/" + id + '/',
            data: form_receipt_note
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Receipt_document {
    constructor() {

    }

    static get_form_receipt_document() {
        return {
            user: null,
            receipt: null,
            document: null,
            title: null,
            size: null,
        }
    }

    static async get_receipt_documents_by_receipt_id(id) {
        let documents
        await axios({
            method: "get",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipt-notes?receipt=" + id,
        })
            .then((response) => {
                documents = response.data.results;
            })
            .catch((error) => {
                console.log(error);
            });
        return documents;
    }

    static async create_receipt_document(form_receipt_document) {
        await axios({
            method: "post",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipt-notes/",
            data: form_receipt_document
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }

    static async delete_receipt_document(id) {
        await axios({
            method: "delete",
            url:
                process.env.VUE_APP_PRODUCTS_API +
                "receipt-notes/" + id,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            });
    }
}

class Price {
    constructor() {
    }

    static get_form() {
        return {
            price_level: null,
            order: 0,
            active: false,
            price: 0,
            product: null,
        }
    }

    static get_price_levels_choices() {
        return [
            {text: "Prix d'achat", value: "purchase_price"},
            {text: "Prix Revendeur", value: "reseller_price"},
            {text: "Prix de vente conseillé", value: "advised_sale_price"},
        ]
    }

}

class Stock_movement {
    constructor() {
    }

    static get_form() {
        return {
            departure_area: null,
            target_area: null,
            status: null,
            date: null,
            number: null,
        }
    }

    static get_stock_movement_status_choices() {
        return [
            {value: "pending", text: "En attente"},
            {value: "finish", text: "Terminé"},
            {value: "canceled", text: "Annulé"},
        ]
    }

    static get_receipt_season_choices() {
        return [
            {value: "summer", text: "Réceptionné"},
            {value: "winter", text: "En attente"},
            {value: "autumn", text: "Annulé"},
            {value: "spring", text: "Printemps"},
        ]
    }
}

class Order_return {
    constructor() {
    }

    static get_order_return_status_choices() {
        return [
            {value: "pending", text: "En attente"},
            {value: "delivered", text: "Livré"},
            {value: "canceled", text: "Annulé"},
            {value: "finish", text: "Terminé"}
        ]
    }
}

class Service {
    constructor() {
    }

    static get_form() {
        return {
            reference: null,
            name: null,
            tags: [],
        }
    }
}


module.exports.Delivery = Delivery;
module.exports.Manufacturer_note = Manufacturer_note;
module.exports.Manufacturer_document = Manufacturer_document;
module.exports.Manufacturer = Manufacturer;
module.exports.Product_variation = Product_variation;
module.exports.Product_pack_item = Product_pack_item;
module.exports.Product_pack = Product_pack;
module.exports.Product = Product;
module.exports.Delivery_line = Delivery_line;
module.exports.Delivery_note = Delivery_note;
module.exports.Delivery_document = Delivery_document;
module.exports.Order = Order;
module.exports.Purchase_order = Purchase_order;
module.exports.Client_delivery = Client_delivery;
module.exports.Client_delivery_document = Client_delivery_document;
module.exports.Client_delivery_note = Client_delivery_note;
module.exports.Receipt = Receipt;
module.exports.Receipt_document = Receipt_document;
module.exports.Receipt_note = Receipt_note;
module.exports.Stockage_area = Stockage_area;
module.exports.Price = Price;
module.exports.Stock_movement = Stock_movement;
module.exports.Order_return = Order_return;
module.exports.Service = Service;